import { EntityName } from '@gr/shared/enums';
import {
  FilterDataTypeEnum,
  FilterOperatorEnum,
  IClientView,
  ISearchRequest,
  SearchSortDirectionEnum,
} from '@gr/shared/models';
import { IColumn, IColumnClickConfig } from '../shared/Table/types';

// Render functions supplied by the parent component (Clients.tsx) where JSX is legal. Keeps this
// plain-TS file free of JSX while following the existing columnRenders convention (e.g. OptOuts).
export interface IColumnRenderConfig {
  [key: string]: (item?: IClientView) => JSX.Element;
}

export const defaultClientTableOptions: ISearchRequest = {
  entity: EntityName.ALL_CLIENTS_VIEW,
  filters: [],
  pagination: {
    skip: 0,
    take: 25,
  },
  sort: {
    fieldName: 'createdAt',
    sortDirection: SearchSortDirectionEnum.DESC,
  },
};

export const noAllClientsClientTableOptions: ISearchRequest = {
  entity: EntityName.ALL_CLIENTS_VIEW,
  filters: [
    {
      dataType: FilterDataTypeEnum.STRING,
      fieldName: 'id',
      operator: FilterOperatorEnum.NOT_EQUALS,
      value: '11111111-1111-1111-1111-111111111111'
    }
  ],
  pagination: {
    skip: 0,
    take: 25,
  },
  sort: {
    fieldName: 'createdAt',
    sortDirection: SearchSortDirectionEnum.DESC,
  },
};

export const allEnabledClientsSearchOptions: ISearchRequest = {
  entity: EntityName.ALL_CLIENTS_VIEW,
  filters: [
    {
      dataType: FilterDataTypeEnum.BOOLEAN,
      fieldName: 'isActive',
      operator: FilterOperatorEnum.EQUALS,
      value: true,
    },
  ],
  pagination: {
    skip: 0,
    take: 10,
  },
  sort: {
    fieldName: 'name',
    sortDirection: SearchSortDirectionEnum.ASC,
  },
};

export const getColumns = (
  columnClickEvents: IColumnClickConfig,
  columnRenders: IColumnRenderConfig,
  isProviderUpdatedVisible: boolean
): IColumn[] => {
  const columns: IColumn[] = [
    {
      headerName: 'Name',
      fieldName: 'name',
      isRowHeader: true,
      fieldType: FilterDataTypeEnum.STRING,
      onColumnClick: columnClickEvents['name'],
      // Custom render (defined in Clients.tsx) appends the GR_ADMIN-only priority pill (MES-2528)
      // after the client name. The <td> wrapper in Table.tsx still wires onColumnClick and the
      // clickable-name styling, so the click-to-open-details behavior is preserved.
      renderColumn: columnRenders['name'],
    },
    {
      headerName: 'Status',
      fieldName: 'isActive',
      fieldType: FilterDataTypeEnum.BOOLEAN,
    },
    {
      headerName: 'Active Carrier Exclusion',
      fieldName: 'hasExclusion',
      fieldType: FilterDataTypeEnum.BOOLEAN,
    },
    {
      headerName: 'Created Date',
      fieldName: 'createdAt',
      fieldType: FilterDataTypeEnum.DATE,
    },
  ];

  if (isProviderUpdatedVisible) {
    columns.splice(2, 0, {
      headerName: 'Provider Updated',
      fieldName: 'providerUpdatedAt',
      fieldType: FilterDataTypeEnum.DATE,
    });
  }

  return columns;
};

export const exclusionBreakdownColumns: IColumn[] = [
  {
    headerName: 'Carrier',
    fieldName: 'carrierName',
    fieldType: FilterDataTypeEnum.STRING,
    isRowHeader: true,
  },
  {
    headerName: 'Provider',
    fieldName: 'providerName',
    fieldType: FilterDataTypeEnum.STRING,
  },
  {
    headerName: 'Campaign Type',
    fieldName: 'campaignType',
    fieldType: FilterDataTypeEnum.ENUM,
  },
  {
    headerName: 'Message Type',
    fieldName: 'messageType',
    fieldType: FilterDataTypeEnum.ENUM,
  },
];
